module.exports = __webpack_public_path__ + "img/ice_cold_shot_greenOLD1.57cf2ca1.png";